interface KeyPoint {
	input: number
	realValue: number
}

const min = 0
export const max = 10_000_000

const keyPoints: KeyPoint[] = [
	{ input: 0, realValue: min },
	{ input: 4, realValue: 5_000 },
	{ input: 38, realValue: 150_000 },
	{ input: 74, realValue: 250_000 },
	{ input: 100, realValue: max },
]

const roundingThresholds = {
	first: 150_000,
	second: 250_000,
}

const roundingFactors = {
	first: 1_000,
	second: 10_000,
	third: 100_000,
}

function findSegment(value: number, isInput: boolean): { start: KeyPoint; end: KeyPoint } {
	let start = keyPoints[0]
	let end = keyPoints[keyPoints.length - 1]

	for (let i = 0; i < keyPoints.length - 1; i++) {
		if (
			isInput
				? value >= keyPoints[i].input && value <= keyPoints[i + 1].input
				: value >= keyPoints[i].realValue && value <= keyPoints[i + 1].realValue
		) {
			start = keyPoints[i]
			end = keyPoints[i + 1]
			break
		}
	}

	return { start, end }
}

function adjustValueForRounding(value: number): number {
	if (value <= roundingThresholds.first) {
		return Math.round(value / roundingFactors.first) * roundingFactors.first
	} else if (value <= roundingThresholds.second) {
		return Math.round(value / roundingFactors.second) * roundingFactors.second
	}
	return Math.round(value / roundingFactors.third) * roundingFactors.third
}

export function calculateRealValueFromInput(input: number): number {
	const { start, end } = findSegment(input, true)
	const scale = (input - start.input) / (end.input - start.input)
	const preciseValue = start.realValue + scale * (end.realValue - start.realValue)
	return adjustValueForRounding(preciseValue)
}

export function calculateInputFromRealValue(realValue: number): number {
	realValue = adjustValueForRounding(realValue)
	const { start, end } = findSegment(realValue, false)
	const scale = (realValue - start.realValue) / (end.realValue - start.realValue)
	return start.input + scale * (end.input - start.input)
}
